<template>
    <el-row>
        <el-col :span="24">
            <div class="row-br"></div>
            <div class="brand-v-logo">
                <!-- <el-image
                    src="https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg"
                    :fit="fit"></el-image> -->
                <el-image
                    :src="logo_raw_path"
                    fit="fill"></el-image>
            </div>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                <span class="title-login-tab">登录 - 天下行巡更系统</span>
                </div>
                <div class="text item">
                    <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="账号" prop="username">
                            <el-col :span="18">
                                <el-form-item>
                                    <el-input v-model="ruleForm.username"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6"></el-col>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-col :span="18">
                                <el-form-item>
                                    <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="6"></el-col>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-checkbox-group v-model="ruleForm.remember_login">
                                <el-checkbox label="记住账号密码" name="remember_login"></el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" v-bind:disabled="submit_bin.disabled" :loading="login_loading" @click="loginForm('ruleForm')">
                                {{ submit_bin.text }}
                            </el-button>
                        </el-form-item>
                        <el-form-item v-if="showLoginResultMessage">
                            <span class="msg-login-result">{{ loginResultMessage }}</span>
                        </el-form-item>
                    </el-form>
                </div>
            </el-card>
        </el-col>
    </el-row>
</template>

<script>
import Api from '../api/index'

export default {
    data() {
        return {
            logo_raw_path: require("@/assets/login-part.png"),
            loginResultMessage: "",
            showLoginResultMessage: false,
            ruleForm: {
                username: "",
                password: "",
                remember_login: false
            },
            submit_bin: {
                disabled: false,
                text: "登 录"
            },
            rules: {
                username: [
                    { required: true, message: '请输入账号', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 4, max: 20, message: '长度在 4 到 20 个字符', trigger: 'blur' }
                ],
            },
            login_loading: false,
        }
    },
    methods: {
        initLoginForm: function() {
            var inputs = document.getElementsByTagName("input");
            inputs[0].focus();

            var _self = this;
            document.onkeydown = function(e) {
              var key = window.event.keyCode;
              if (key == 13) {
                _self.loginForm('ruleForm'); // 登录的方法
              }
            }

            if(localStorage.getItem("remember_login")) {
                this.ruleForm.username = localStorage.getItem("user_name") && localStorage.getItem("user_name") != "undefined" ?
                                localStorage.getItem("user_name") : "";
                this.ruleForm.password = localStorage.getItem("user_password") && localStorage.getItem("user_password") != "undefined" ?
                                localStorage.getItem("user_password") : "";
                this.ruleForm.remember_login = true;
            }
        },
        loginForm: function(formName) {
            // 初始化全局参数值
            this.loginResultMessage = "";
            this.showLoginResultMessage = false;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.login_loading = true;
                    this.submit_bin.text = "登录中..";
                    //var bate64Pwd = btoa(this.$AccessAuthBase64Prefix + this.ruleForm.password);
                    var argdata = {
                        user_name: this.ruleForm.username,
                        user_password: this.ruleForm.password,
                        remember_login: this.ruleForm.remember_login
                    };
                    
                    Api.UserLogin(argdata).then(res => {
                        if(res && res.code === 200) {
                            this.loginResultMessage = "";
                            if(res.data) {
                                localStorage.setItem("access_token", res.data.token);
                                localStorage.setItem("user_name", res.data.userName);
                                localStorage.setItem("true_name", res.data.trueName);
                                localStorage.setItem("user_type", res.data.userType);
                                localStorage.setItem("service_end", res.data.serviceEnd);
                                localStorage.setItem("remember_login", this.ruleForm.remember_login);
                                if(this.ruleForm.remember_login) {
                                    localStorage.setItem("user_password", this.ruleForm.password);
                                }
                            }
                            this.$router.push("home/dashboard");
                        } else {
                            this.login_loading = false;
                            this.loginResultMessage = "登录失败! 账号或密码不对!";
                            this.showLoginResultMessage = true;
                            this.submit_bin.text = "登 录";
                            this.submit_bin.disabled = false;
                        }
                    }).catch(err => {
                        console.log("Fail! " + err);
                        this.login_loading = false;
                        this.submit_bin.text = "登 录";
                        this.submit_bin.disabled = false;
                        this.loginResultMessage = "服务器抖动一下!请稍后重试登录";
                        this.showLoginResultMessage = true;
                    });

                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
    mounted() {
        this.initLoginForm();
    }
}
</script>


<style>
.box-card {
    margin: 0 auto;
    width: 456px;
}
.box-card .text.item {
    padding-top: 15px;
}
.brand-v-logo {
    margin: 0 auto;
    padding-top: 10px;
    padding-bottom: 15px;
    width: 313px;
}
.msg-login-result {
    color: red;
    font-size: 16px;
}
.title-login-tab {
    font-size: 20px;
}
.row-br {
    width: 100%;
    height: 100px;
}
</style>